import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { NativeService} from '../../../../service/native.service';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
declare var app;


@Component({
  selector: 'app-a2-bind-store',
  templateUrl: './a2-bind-store.component.html',
  styleUrls: ['./a2-bind-store.component.scss']
})
export class A2BindStoreComponent extends GridBaseCase implements AfterViewInit {
  dataArrayPG: Array<any> = [];
  dataArrayStore: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  pageName: string = null;
  roles: string = null;//角色
  selectText: string = null;//选中的门店名字
  bindStoreDate: any = null;
  pgId: any = null;
  storeId: string = null;//门店id
  isSubmit:boolean = true;
  PgSelectInit:boolean = false;//重新渲染select
  StoreSlectInit:boolean = false;//重新渲染select
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService
  ) {
    super();
    let that = this;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    const date = new Date();
    const month = (date.getMonth() + 1) >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
    const day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();
    this.bindStoreDate = date.getFullYear() + "-" + month + "-" + day;
    that.LoadDataInfo(1);//pg
    that.LoadDataInfo(2);//门店
  }
  ngAfterViewInit() {
    let that = this;
   
  }

  LoadDataInfo(type: any = null) {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    body.OpType = "query";
    body.ConfigType = "view";
    body.PageNumber = 0;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if(that.bindStoreDate){
      that.bindStoreDate = that.bindStoreDate.replace("T"," ");
    }
    body.RequestBody = {};
    if (type == 1) {//pg列表
      body.ConfigName = "SystemUserAndStore";
      body.RequestBody = {
        "r_Code":"1002",
        "s_OpType":"ADD",
        "a_EntryDate":that.bindStoreDate
      };
    } else if (type == 2) {
      body.ConfigName = "TBStoreXML";
      body.SpecialParameter = "pgnumunder";
      body.RequestBody = {
        "a_EntryDate":that.bindStoreDate
      };
    }
    console.log(body);
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (data.ResponseMessage.Success) {
        if(type == 1){
          setTimeout(()=>{
            that.PgSelectInit = true;
          },300);
          that.dataArrayPG = data.Status.Datas;
          that.pgId = null;
          if(that.dataArrayPG.length == 0){
            that.dataArrayPG = [{
              a_ID:null,
              a_ChineseName:"暂无可选PG"
            }];
          }
        }else if(type == 2){
          setTimeout(()=>{
            that.StoreSlectInit = true;
          },300);
          that.dataArrayStore = data.Status.Datas;
          that.storeId = null;
          if(that.dataArrayStore.length == 0){
            that.dataArrayStore = [{
              a_ID:null,
              a_Name:"暂无可选门店"
            }];
          }
        }
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  dateChange(e){
    console.log(e.target);
    const that = this;
    that.bindStoreDate = e.target.value || "";
    if(that.bindStoreDate){
      that.PgSelectInit = false;
      that.StoreSlectInit = false;
      that.LoadDataInfo(1);//pg
      that.LoadDataInfo(2);//门店
    }
  }

  dateChange2(){
    let that = this;
    let val = null;
    if(that.bindStoreDate){
      that.bindStoreDate = that.bindStoreDate.replace(/-/g,"/");
      let _date = new Date(that.bindStoreDate);
      val = _date.getFullYear() + "-" + (_date.getMonth()+1) + "-" +_date.getDate();
    }
    let _obj = {
      format:"yyyymmdd",
      value:val
    };
    that.native.IosselectDateTime(_obj).then(data=>{
      let _val = data.value;
      if(_val){
        _val = _val.replace(/-/g,"/");
        const date = new Date(_val);
        const month = (date.getMonth() + 1) >= 10 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
        const day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate();
        this.bindStoreDate = date.getFullYear() + "-" + month + "-" + day;
        that.LoadDataInfo(1);//pg
        that.LoadDataInfo(2);//门店
      }
    })
  }
  //pg
  changeSelect1(e) {
    let that = this;
    that.pgId = e.target.value || "";
  }

  //门店
  changeSelect2(e){
    let that = this;
    that.storeId = e.target.value || "";
  }
  

  submit(){
    let that = this;
    if(!that.isSubmit){
      return;
    }else{
      that.isSubmit = false;
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "FormUserjurisdictionAndTBStoreRelation";
    body.Account = that.com.GetAccount;
    body.OpType = "add";
    body.ConfigType = "form";
    body.Client.PageName = PageName;
    if(that.bindStoreDate){
      that.bindStoreDate = that.bindStoreDate.replace("T"," ").replace("Z","").replace("-00:00","");
    }else {
      that.msg.Alert("请选择日期");
      that.isSubmit = true;
      return;
    }
    if(!that.pgId){
      that.msg.Alert("请选择PG");
      that.isSubmit = true;
      return;
    }
    if(!that.storeId){
      that.msg.Alert("请选择门店");
      that.isSubmit = true;
      return;
    }
    body.RequestBody = [{
      a_EntryDate:that.bindStoreDate,
      a_FK_SystemUser_ID:that.pgId,
      a_FK_Store_ID:that.storeId,
    }];
   
    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.isSubmit = true;
      if (data.ResponseMessage.Success) {
        that.msg.Alert("入店成功").then(()=>{
          that.com.goBack();
        });
      }
    }).catch(error => {
      that.isSubmit = true;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
}
